import React from "react";
import { Box, Typography } from "@mui/material";
import { getStatusDisplayText } from "./designUtils";

/**
 * Design preview card: image with status + version badges, footer with type label.
 */
export default function DesignDesignCard({ design, imageMaxHeight = 220, maxWidth = 360 }) {
  if (!design) return null;
  const statusLabel = design.status ? getStatusDisplayText(String(design.status)) : "—";
  const versionLabel = design.version != null ? `v${design.version}` : "—";

  return (
    <Box
      sx={{
        borderRadius: "12px",
        border: "1px solid #E4E5E7",
        overflow: "hidden",
        backgroundColor: "#fff",
        maxWidth,
        width: "100%",
      }}
    >
      <Box sx={{ position: "relative", backgroundColor: "#f3f4f6" }}>
        <img
          src={design.image_url}
          alt={design.type || "Design"}
          style={{
            width: "100%",
            height: "auto",
            maxHeight: imageMaxHeight,
            objectFit: "cover",
            display: "block",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: 10,
            left: 10,
            display: "flex",
            gap: "6px",
            flexWrap: "wrap",
          }}
        >
          <Typography
            sx={{
              fontSize: "11px",
              fontWeight: 600,
              px: 1.25,
              py: 0.35,
              borderRadius: "6px",
              backgroundColor: "rgba(255,255,255,0.92)",
              color: "#374151",
              border: "1px solid #e5e7eb",
              textTransform: "capitalize",
            }}
          >
            {statusLabel}
          </Typography>
          <Typography
            sx={{
              fontSize: "11px",
              fontWeight: 600,
              px: 1.25,
              py: 0.35,
              borderRadius: "6px",
              backgroundColor: "rgba(255,255,255,0.92)",
              color: "#374151",
              border: "1px solid #e5e7eb",
            }}
          >
            {versionLabel}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ px: 2, py: 1.5, borderTop: "1px solid #E4E5E7" }}>
        <Typography sx={{ fontSize: "15px", fontWeight: 700, color: "#0d0d0e" }}>
          {design.type || "—"}
        </Typography>
      </Box>
    </Box>
  );
}
